import { render, staticRenderFns } from "./checkboxWithTextMatchMaking.vue?vue&type=template&id=2fd67f2d&scoped=true"
import script from "./checkboxWithTextMatchMaking.vue?vue&type=script&lang=js"
export * from "./checkboxWithTextMatchMaking.vue?vue&type=script&lang=js"
import style0 from "./checkboxWithTextMatchMaking.vue?vue&type=style&index=0&id=2fd67f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd67f2d",
  null
  
)

export default component.exports